module.exports = __webpack_public_path__ + "img/2935.a5d1ed0e.svg";